(function () {
    let items = document.querySelectorAll('ul.collapsible > li > a');

    if (items) {
        items.forEach(i => {
            i.addEventListener('click', function (e) {
                e.preventDefault();

                let sub = this.nextElementSibling;
                sub.classList.toggle('expand');

                this.classList.toggle('opened');
            });
        });
    }
})();